import { StandardEvents } from '@shopify/events';

/**
 * SOLIVA discount badge.
 *
 * Mirrors the update mechanism used by `product-price.js`: when a variant is
 * selected the theme re-renders the section and dispatches `productSelect`
 * with the fresh HTML. We swap in the matching badge so the discount always
 * reflects the currently selected variant — never a hardcoded value.
 */
class SolivaDiscountBadge extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
    this.section = null;
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector(`soliva-discount-badge[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        const current = this.querySelector('[ref="badgeContainer"]');
        const incoming = next.querySelector('[ref="badgeContainer"]');
        if (!current || !incoming) return;

        current.replaceWith(incoming.cloneNode(true));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[soliva-discount-badge] update failed:', error);
      });
  };
}

if (!customElements.get('soliva-discount-badge')) {
  customElements.define('soliva-discount-badge', SolivaDiscountBadge);
}
